import { render, staticRenderFns } from "./DictionarySelect.vue?vue&type=template&id=3ee268d8&scoped=true&"
import script from "./DictionarySelect.vue?vue&type=script&lang=ts&"
export * from "./DictionarySelect.vue?vue&type=script&lang=ts&"
import style0 from "./DictionarySelect.vue?vue&type=style&index=0&id=3ee268d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee268d8",
  null
  
)

export default component.exports